/* eslint-disable */
import React from 'react';

import { Breakpoint, Theme, TypographyProps } from '@mui/material';

import useGetCurrentBreakPoint from './hooks/useGetCurrentBreakPoint';
import StyledMediaTypography from './styled';

type VariantMap = Partial<Record<Breakpoint, TypographyProps['variant']>>;

type LineClampMap = Partial<Record<Breakpoint, number>> & {
	default?: number;
};

interface MediaTypographyProps extends TypographyProps {
	variants?: VariantMap;
	children?: React.ReactNode;
	lineClamp?: LineClampMap;
	textColor?: keyof Theme['palette']['text'];
}

function MediaTypography({
	variants,
	variant,
	lineClamp,
	textColor,
	...props
}: MediaTypographyProps) {
	const currentVariantBreakpoint = useGetCurrentBreakPoint(variants || {});
	const currentLineClampBreakpoint = useGetCurrentBreakPoint(lineClamp || {});

	const currentVariant = currentVariantBreakpoint ? variants[currentVariantBreakpoint] : variant;
	const currentLineClamp = currentLineClampBreakpoint
		? lineClamp?.[currentLineClampBreakpoint]
		: lineClamp?.default;

	return (
		<StyledMediaTypography
			variant={currentVariant}
			//@ts-ignore
			lineClamp={currentLineClamp}
			textColor={textColor}
			{...props}
		/>
	);
}

export default MediaTypography;
